import {AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {EnumFiltroDePedidos, PedidosService} from "../../services/pedidos.service";
import {interval, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from "@angular/router";
import {GridPedidosComponent} from "../grid-pedidos/grid-pedidos.component";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ModalFinalizarPedidosComponent} from "../../fidelidade/modal-finalizar-pedidos/modal-finalizar-pedidos.component";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {PedidoLocalService} from "../../services/pedido-local.service";
import {leiaFlagPdvNovoV3Local, obtenhaRotaNovoPedidoLocal, salveFlagPdvNovoV3Local} from "../pdv-local-config";
import {EnumStatusPedido, StatusPedidoLabel} from "../../../../server/lib/emun/EnumStatusPedido";
import {ImpressaoService} from "../../services/impressao.service";

const secondsCounter = interval(1000 * 30);
declare var _;
declare var $;
declare var moment;

@Component({
  selector: 'app-tela-acompanhar-pedidos',
  templateUrl: './tela-acompanhar-pedidos.component.html',
  styleUrls: ['./tela-acompanhar-pedidos.component.scss']
})
export class  TelaAcompanharPedidosComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('gridPedidos', { static: true}) gridPedidos: GridPedidosComponent;
  pedidos = [];
  novosPedidos = [];
  pedidosContestados = [];
  pedidosEnderecoAlterado = [];
  falhasNaImportacao = []
  paginacao = { total: 1000};
  carregando: any = false;
  @Input() empresa: any = {}
  resumoPedidos: any = { total: 0 , emPreparacao: 0, emEntrega: 0 , novos: 0}
  page: any = 0;
  pedidoAlterar: any;
  timerPedidos;

  mensagemSucesso: string;
  novoPedido: any;
  exibirPedidoInterno = false;
  producaoInternaAtiva() {
    return !!this.empresa && (this.empresa.producaoPedidosAtiva === true || Number(this.empresa.producaoPedidosAtiva) === 1);
  }

  criouPedidoInterno(pedido: any) {
    this.exibirPedidoInterno = false;
    this.router.navigate(['/admin/pedidos/detalhes', pedido.guid]);
  }
  ultimaAtualizacao: any;
  usuario = null;
  @Input() mesa: boolean;
  @Input() apenasAgendados: boolean;
  @Input() apenasFiados: boolean;
  objFiltro: any = {
    q: '',
    statuses: [],
    filtroImpressao: null
  };
  opcoesFiltroImpressao: any[] = [{id: 0, descricaoFiltro: 'Não impressos nunca'}];
  private inscricaoPedidoImpresso: Subscription;
  statusPedidos = [
    EnumStatusPedido.Novo,
    EnumStatusPedido.EmPreparacao,
    EnumStatusPedido.Pronto,
    EnumStatusPedido.SaiuParaEntrega,
    EnumStatusPedido.Entregue
  ].map((status) => ({ valor: status, descricao: StatusPedidoLabel.get(status) }));
  timerBusca: any;
  ordenarPorCodigo = false;
  usarTelaNovaPdv = false;
  constructor(private pedidosService: PedidosService, private router: Router,
              public monitoradorPedidos: MonitoradorPedidos, private dialogService: DialogService,
              private pedidoLocalService: PedidoLocalService,
              private route: ActivatedRoute, private autorizacaoService: AutorizacaoService,
              private impressaoService: ImpressaoService) {


    if(localStorage.getItem('ordenarPorCodigo') != null)
        this.ordenarPorCodigo = true;

  }

  ngOnInit() {
    this.usarTelaNovaPdv = leiaFlagPdvNovoV3Local();
    this.usuario = this.autorizacaoService.getUser();
    if(this.route.snapshot.routeConfig.path.endsWith('erros'))
      this.objFiltro.comErros = true;


    if(this.route.snapshot.routeConfig.path.endsWith('onlineaguardando'))
      this.objFiltro.onlineAguardando = true;

    if(this.route.snapshot.routeConfig.path.endsWith('contestados'))
      this.objFiltro.contestados = true;

    if(this.route.snapshot.routeConfig.path.endsWith('alteracaoendereco'))
      this.objFiltro.alteracaoendereco = true;

    delete this.mensagemSucesso
    delete  this.novoPedido

    // A home manda o operador para cá já filtrado ("3 novos" → só os novos).
    const statusDaHome = this.route.snapshot.queryParams.status;
    if (statusDaHome !== undefined && statusDaHome !== '' && !isNaN(Number(statusDaHome)))
      this.objFiltro.statuses = [Number(statusDaHome)];

    if( this.route.snapshot.queryParams.msg){
      this.mensagemSucesso = this.route.snapshot.queryParams.msg
      this.novoPedido = { codigo: this.route.snapshot.queryParams.codigo}
    }

    if(window.history.state.mensagem){
      this.mensagemSucesso =  window.history.state.mensagem
      this.novoPedido = { codigo:  window.history.state.codigo}
    }

    if(this.apenasAgendados && !this.objFiltro.dia)
      this.objFiltro.dia = new Date();

    this.carreguePedidos();

    this.inscricaoPedidoImpresso = this.impressaoService.onPedidoImpresso.subscribe((dados: any) => {
      const idImpressora = this.obtenhaIdImpressoraFiltro();
      if(this.objFiltro.filtroImpressao === 0 ||
        (idImpressora && Number(dados?.impressora?.id) === idImpressora))
        this.carreguePedidos();
    });

    this.timerPedidos = secondsCounter.subscribe(n =>
      this.carregueNovosPedidos());

  }

  ngOnDestroy(){
    this.timerPedidos.unsubscribe();
    if(this.inscricaoPedidoImpresso)
      this.inscricaoPedidoImpresso.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.empresa)
      this.atualizeOpcoesFiltroImpressao();
  }

  private atualizeOpcoesFiltroImpressao() {
    const impressoras = this.empresa?.configImpressao?.impressoras || [];
    this.opcoesFiltroImpressao = [
      {id: 0, descricaoFiltro: 'Não impressos nunca'},
      ...impressoras
      .filter((impressora: any) => impressora && !impressora.removida)
      .map((impressora: any) => ({
        id: impressora.id,
        descricaoFiltro: `Não impressos em "${impressora.setor || impressora.nome}"`
      }))
    ];
  }

  onFilter($event: any) {
    if(this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout(() =>  {
      this. carreguePedidos();
    }, 1000)
  }


  alterouDia(){
    if(!this.objFiltro.dia) {
      delete this.objFiltro.horaInicio;
      delete this.objFiltro.horaFim;
    }

    if(this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout(() =>  {
      this. carreguePedidos();
    }, 1000)
  }

  limpeFiltros(){
    this.objFiltro.statuses = [];
    this.objFiltro.filtroImpressao = null;
    delete this.objFiltro.dia;
    delete this.objFiltro.horaInicio;
    delete this.objFiltro.horaFim;

    this.carreguePedidos();
  }

  alterouHorario(){
    if(!this.objFiltro.dia) return;

    if(this.objFiltro.horaInicio && this.objFiltro.horaFim){
      if(this.timerBusca) clearTimeout(this.timerBusca);

      this.timerBusca = setTimeout(() =>  {
          this. carreguePedidos();
      }, 1000)
    }
  }

  alterouFiltroImpressao(){
    this.carreguePedidos();
  }

  carreguePedidos(){
    if(this.carregando) return;

    let filtro: any = { };

    this.setFiltrosComuns(filtro);

    this.carregando = true;

    this.pedidosService.listePedidos(0, this.paginacao.total, filtro, filtro.filtroEmum).then( (resposta) => {
      this.pedidos = resposta.pedidos || [];
      this.pedidosContestados = resposta.contestados || [];
      this.pedidosEnderecoAlterado = resposta.pedidosEnderecoAlterado || [];
      this.falhasNaImportacao = resposta.falhasNaImportacao || [];
      this.ultimaAtualizacao = resposta.ultimaAtualizacao;
      this.setPedidosExibir();

      this.carregando = false;
    }).catch( () => {
      this.carregando = false;
    });
  }

  setPedidosExibir(){
    let pedidosFiltrados = this.pedidos;

    if(this.objFiltro.filtroImpressao === 0)
      pedidosFiltrados = this.pedidos.filter((pedido: any) => !pedido.impresso);

    if(this.objFiltro.comErros)
      pedidosFiltrados = this.pedidos.filter((pedido: any) => pedido.erroExterno);

    if(this.objFiltro.onlineAguardando)
      pedidosFiltrados = this.pedidos.filter((pedido: any) => pedido.aguardandoPagamentoOnline);

    if(this.objFiltro.contestados)
      pedidosFiltrados = this.pedidosContestados;

    if(this.objFiltro.alteracaoendereco)
      pedidosFiltrados =  this.pedidosEnderecoAlterado;

    this.gridPedidos.atualizeGridPedidos(pedidosFiltrados, 'em-aberto', true);

    this.setResumoPedidos(pedidosFiltrados);

    this.monitoradorPedidos.notifiqueResumo(this.pedidos, this.pedidosContestados, this.falhasNaImportacao)
  }

  carregueNovosPedidos(){
    if(this.carregando) return;

    if(this.obtenhaIdImpressoraFiltro()) {
      this.carreguePedidos();
      return;
    }

    let filtro: any = {   ultimaAtualizacao: this.ultimaAtualizacao };

    this.setFiltrosComuns(filtro)

    this.carregando = true;

    this.pedidosService.listePedidos(0, this.paginacao.total, filtro ,  filtro.filtroEmum).then( (resposta: any) => {

      if(resposta.pedidos.length){
        this.ultimaAtualizacao = resposta.ultimaAtualizacao;
        resposta.pedidos.forEach((pedido: any) => {
          let pedidoExisente = this.pedidos.find( pedidoLocal => pedidoLocal.id === pedido.id)

          if(!pedidoExisente){
            this.pedidos.push(pedido);
            this.novosPedidos.push(pedido);
          } else {
            let indice = this.pedidos.indexOf(pedidoExisente);
            this.pedidos[indice]  = pedido;
          }
        });

        this.setPedidosExibir();
      }

      this.carregando = false;
    }).catch( () => {
      this.carregando = false;
    });
  }


  setFiltrosComuns(filtro: any){
    if(this.apenasFiados)
      filtro.fiadosNaoPagos = true;
    else
      filtro.emAberto =  true;

    if(this.objFiltro.q) filtro.q = this.objFiltro.q
    if(this.objFiltro.statuses && this.objFiltro.statuses.length)
      filtro.statuses = this.objFiltro.statuses;
    const idImpressora = this.obtenhaIdImpressoraFiltro();
    if(idImpressora)
      filtro.idImpressoraSemImpressao = idImpressora;

    let filtroEmum = EnumFiltroDePedidos.pedidos;

    if( this.mesa )
      filtroEmum = EnumFiltroDePedidos.comanda;

    if (this.apenasAgendados)
      filtroEmum = EnumFiltroDePedidos.agendados;

    filtro.filtroEmum = filtroEmum;

    delete this.objFiltro.filtroData;

    if(this.objFiltro.dia){
      this.objFiltro.filtroData = true;
      filtro.dia = moment(this.objFiltro.dia).format('YYYYMMDD');

      if(this.objFiltro.horaInicio && this.objFiltro.horaFim) {
        delete  filtro.dia;

        const inicio =  moment(this.objFiltro.dia).set({
          hour: this.objFiltro.horaInicio.getHours(),
          minute: this.objFiltro.horaInicio.getMinutes(),
          second: 0
        });

        const fim = moment(this.objFiltro.dia).set({
          hour: this.objFiltro.horaFim.getHours(),
          minute: this.objFiltro.horaFim.getMinutes(),
          second: 0
        });

        filtro.dtInicio = inicio.format('YYYYMMDDHHmmss');
        filtro.dtFim = fim.format('YYYYMMDDHHmmss');
      }
    }
  }

  private obtenhaIdImpressoraFiltro(): number {
    const idImpressora = Number(this.objFiltro.filtroImpressao);
    return Number.isInteger(idImpressora) && idImpressora > 0 ? idImpressora : null;
  }

  setResumoPedidos(pedidos: any){
    this.resumoPedidos.total = pedidos.length;
    this.resumoPedidos.emPreparacao = _.filter(pedidos, {status: 'Em preparação'}).length;
    this.resumoPedidos.emEntrega = _.filter(pedidos, {status: 'Saiu para entrega'}).length;
    this.resumoPedidos.novos = _.filter(pedidos, {status: 'Novo'}).length;
  }

  imprimaPedido(pedido: any) {
    window.open('/imprimir/pedido/' + pedido.guid);
  }


  fecheMensagemSucesso() {
    delete  this.mensagemSucesso;
  }


  vaParaNovoPedido(balcao = null) {
    const rotaPedido = obtenhaRotaNovoPedidoLocal();
    let url = rotaPedido + '?urlRetorno=' + window.location.pathname;

    if(balcao){
      url += '&bal=1'
      this.pedidoLocalService.removaPedido('balcao');
    }

    this.router.navigateByUrl(url).catch( () => {});
  }

  alterouUsarTelaNovaPdv(usarTelaNovaPdv: boolean) {
    this.usarTelaNovaPdv = usarTelaNovaPdv;
    salveFlagPdvNovoV3Local(usarTelaNovaPdv);
  }

  abraModalFinalizar(){

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalFinalizarPedidosComponent,
      minWidth: 250,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.pedidos = this.pedidos;

    windowRef.result.subscribe( (result: any) => {
        if(result)
           this.carreguePedidos();
      } );

  }
}
